import { useMemo } from 'react';

import HeaderGroupWithIcon from '@feat/reports/components/header-group-with-icon.renderer';

export const useDefaultColumnGroupDefinition = () => {
  return useMemo(() => {
    return {
      children: [],
      filter: true,
      headerGroupComponent: HeaderGroupWithIcon,
      headerGroupComponentParams: {
        headerGroupComponent: HeaderGroupWithIcon,
      },
    };
  }, []);
};
